import { render, staticRenderFns } from "./LoadingBackground.vue?vue&type=template&id=21a9fc42&"
import script from "./LoadingBackground.vue?vue&type=script&lang=js&"
export * from "./LoadingBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports